export class LoopAbleList<T> {
    private _list: T[];
    private _index: number;
    private _randomizeOnWrapAround: boolean = false;

    constructor(_list: T[]) {
        this._index = -1;
        this._list = _list;
    }

    public next(): T {
        const index: number = this.increment();
        return this._list[index];
    }

    public setRandomizeAtWrapAround(randomize: boolean): LoopAbleList<T> {
        this._randomizeOnWrapAround = randomize;
        return this;
    }

    private increment(): number {
        this._index++;
        this._index %= this._list.length;
        if (this._index === 0 && this._randomizeOnWrapAround) {
            this._list = this.shuffleArray(this._list);
        }
        return this._index;
    }

    private shuffleArray(array: any[]): any[] {
        let a: any[] = array.concat();
        for (let i: number = a.length; i; i--) {
            let j: number = Math.floor(Math.random() * i);
            [a[i - 1], a[j]] = [a[j], a[i - 1]];
        }

        return a;
    }
}